import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PartnerForm from '../components/PartnerForm';
import { cancelPartnerCreate, createPartnerRequest } from '../../api/partners/partnerSlice';
import { useDispatch, useSelector } from 'react-redux';

const PartnerCreatePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isPartnerCreated } = useSelector((state) => state.partners);

  useEffect(() => {
    if (isPartnerCreated) {
      navigate('/partners');
    }
  }, [isPartnerCreated, navigate]);

  const handleCreate = async (data) => {
    dispatch(createPartnerRequest(data));
  };

  function handleCancel() {
    dispatch(cancelPartnerCreate());
    return navigate('/partners');
  }

  return (
    <Box elevation={3} sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Create Partner
      </Typography>
      <PartnerForm
        onSubmit={handleCreate}
        onCancel={handleCancel}
        buttonText="Save"
        initialData={{ name: '', email: '', role: 'partner' }}
      />
    </Box>
  );
};

export default PartnerCreatePage;
